import React, { memo } from "react";
import styles from "./service-request-list-item.module.scss";
import CircularProgress from "../../../../../common/components/circular-progress/CircularProgress";

interface ServiceRequestListItemProps {
	title: string;
	date: string;
	amount?: string;
	percentage?: number;
	status?: string | null;
	onTap: () => void;
}

const ServiceRequestListItem: React.FC<ServiceRequestListItemProps> = memo(({
	title,
	date,
	amount,
	percentage,
	status,
	onTap,
}) => {
	return (
		<button className={styles.row} onClick={onTap}>
			<div className={styles.inner}>
				{percentage !== undefined && (
					<CircularProgress
						percentage={percentage}
						size={38}
						textColor="var(--app-primary-text-08)"
						trackColor="rgba(255, 180, 0, 0.2)"
					/>
				)}

				<div className={styles.middleColumn}>
					<span className={styles.title}>{title}</span>
					<span className={styles.date}>{date}</span>
				</div>

				<div className={styles.rightColumn}>
					{amount && <span className={styles.amount}>{amount}</span>}
					{status && <span className={styles.status}>{status}</span>}
				</div>
			</div>
		</button>
	);
});

export default ServiceRequestListItem;
